import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import BuyOption from './BuyOption.js';

// ES6 class-style
class PageBannerBuy extends PreLoginSessionCheck {
	constructor(props) {
		super(props);
		this.productDetails = localStorage.getItem('proDetail');

		this.getBuyOptions = this.getBuyOptions.bind(this);
	}

	getProductDetails(){
		//console.log(JSON.parse(this.productDetails));
		if(this.productDetails != {} && this.productDetails != undefined){
			return JSON.parse(this.productDetails);
		}else{
			return {};
		}
	}


	componentDidMount(){
		var clsName=this.removeWhiteSpace(this.getProductDetails()[this.props.id].ClassName)
		console.log("lalala", clsName);
		this.setTitle(clsName+"_title");
		this.setMeta(clsName+"_meta");
		this.setHeading(clsName+"_heading");
	}

	
	getBuyOptions(){
  	return (<BuyOption id={this.props.id} triedFree={this.props.triedFree} purchased={this.props.purchased} showSubScripeLoginForm={this.props.showSubScripeLoginForm} productBase={this.props.productBase} simpleform={this.props.simpleform}></BuyOption>);
  }

  render() {
  	var classname = this.getProductDetails()[this.props.id].ClassName;
  	return(
  		<section className={this.props.classes}>
  		<div className="container"> 
  		<h1>{this.props.name} for {classname}</h1>   
  		<h2>{this.props.text}</h2>
  		<hr className="buyoptionline"/>
  		{this.getBuyOptions()}
  		</div> 
  		</section>
  		);
  	}
  }

  export default PageBannerBuy;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/PageBannerBuy.js